// removed by extract-text-webpack-plugin
module.exports = {"layout-boxed-wrapper":"layout-boxed-wrapper___1hpl0","layout-boxed-main":"layout-boxed-main___2ZLU9","layout-boxed-content-wrapper":"layout-boxed-content-wrapper___TE9Rj","layout-boxed-content":"layout-boxed-content___3zCdP"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/layout-boxed/layout-boxed.module.scss
// module id = 1355
// module chunks = 82